import React from "react";

export const Video = (props) => {
  const { youtube, name, description, duration, uploaded, vimeo } = props;

  return (
    <>
      <div
        className="video-embed"
        itemProp="video"
        itemScope
        itemType="http://schema.org/VideoObject"
      >
        {name && <meta itemProp="name" content={name} />}
        {description && <meta itemProp="description" content={description} />}
        {duration && <meta itemProp="duration" content={duration} />}
        {uploaded && <meta itemProp="uploadDate" content={uploaded} />}
        {vimeo && (
          <>
            <div className="video-container">
              <iframe
                title={vimeo}
                className="lozad"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                width="853"
                height="480"
                src={`https://player.vimeo.com/video/${vimeo}`}
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </div>
          </>
        )}
        {youtube && (
          <>
            <meta
              itemProp="thumbnailURL"
              content={`https://i.ytimg.com/vi/${youtube}/maxresdefault.jpg`}
            />
            <meta
              itemProp="embedURL"
              content={`https://youtube.googleapis.com/v/${youtube}`}
            />
            <div className="video-container">
              <iframe
                title={youtube}
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                width="853"
                height="480"
                src={`https://www.youtube-nocookie.com/embed/${youtube}?rel=0&controls=0&showinfo=0`}
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </div>
          </>
        )}
      </div>
    </>
  );
};
